import { Combobox, ScrollArea, TextInput, useCombobox } from '@mantine/core';
import { FieldError, RefCallBack } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { BUSINESS_FIELDS_TRANS_PATH } from '../../../../constants';
import { CompanySiteOptionType } from '../../common';
import { SiteSelectOptions, SiteSelectRightSection } from './components';

type SiteSelectComboboxPropsType = {
  ref: RefCallBack;
  error: FieldError | undefined;
  name: string;
  onBlur: () => void;
  combobox: ReturnType<typeof useCombobox>;
  options: CompanySiteOptionType[];
  shouldShowAddCompany: boolean;
  shouldShowAddCompanySite: boolean;
  search: string;
  handleOptionSubmit: (value: string) => void;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  showClearButton: boolean;
};

export const SiteSelectCombobox: React.FC<SiteSelectComboboxPropsType> = ({
  ref,
  error,
  name,
  onBlur,
  combobox,
  options,
  shouldShowAddCompany,
  shouldShowAddCompanySite,
  search,
  onSearchChange,
  onClear,
  showClearButton,
  handleOptionSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Combobox store={combobox} onOptionSubmit={handleOptionSubmit}>
      <Combobox.Target>
        <TextInput
          ref={ref}
          error={error?.message}
          label={t(`${BUSINESS_FIELDS_TRANS_PATH}.SITE_ID_LABEL`)}
          name={name}
          onBlur={onBlur}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
          onClick={() => combobox.openDropdown()}
          required
          rightSection={
            <SiteSelectRightSection
              ariaLabel={t(
                `${BUSINESS_FIELDS_TRANS_PATH}.CLEAR_SITE_SELECTION`
              )}
              onClear={onClear}
              showClear={showClearButton}
            />
          }
          rightSectionPointerEvents={showClearButton ? 'all' : 'none'}
          value={search}
        />
      </Combobox.Target>
      <Combobox.Dropdown>
        <ScrollArea.Autosize mah={300} type="scroll" scrollbarSize={4}>
          <SiteSelectOptions
            options={options}
            shouldShowAddCompany={shouldShowAddCompany}
            shouldShowAddCompanySite={shouldShowAddCompanySite}
          />
        </ScrollArea.Autosize>
      </Combobox.Dropdown>
    </Combobox>
  );
};
